/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'

import '../peyk.scss'

import { Link, useNavigate } from 'react-router-dom'

import peykLogo from '../../../assets/svg/PeykLogo.png'
import { post } from '../../../services/https'
import { notify } from '../../../components/Toast'

import { ToastContainer } from 'react-toastify'

import loadingPic from '../../../assets/svg/Loading.svg'

export default function index() {
  const [code, setCode] = useState()
  const [alertCode, setAlertCode] = useState(false)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()
  
  const sendCodeHandler = (e) => {
    e.preventDefault()
    if (code !== undefined && code.length === 4) {
      setAlertCode(false)
      setLoading(true)
      post('/api/front/validatesms', {
          phoneNumber: localStorage.getItem('phoneNumber'),
          code: code
        }, {
        'Content-Type': 'application/json'
        }).then(response => {
          if (response.data.messageFa === "کد معتبر است") {
            navigate('/peyk/dashboard')
            localStorage.setItem('code', code)
          }
        }).catch(error => {
          if (error.response.data.messageFa === "کد معتبر نیست") {
            notify('error', "کد معتبر نیست")
            setLoading(false)
          } else {
            notify('error', 'دریافت اطلاعات با خطا مواجه شد')
          }
        })
    } else {
      setAlertCode(true)
    }
  }

  return (
    <div id='peyk'>
      <ToastContainer rtl />
      <main className="countainer">
        <section className='Logo'>
          <img src={peykLogo} alt="peykLogo" />
        </section>
        <section className='from'>
          <div className="form__phoneNumber">
            <div>
              کد اعتبارسنجی ارسالی به شماره :
            </div>
            <div>
              {localStorage.getItem('phoneNumber')}
            </div>
          </div>
          <div className="form__input">
            <input onChange={(e) => setCode(e.target.value)} className='form__input--ltr' type="number" placeholder='0098 ...' />
            <small style={alertCode ? {} : { display: 'none' }}>کد صحیح نیست</small>
          </div>
          <div className="form__message">
            کد اعتبارسنجی ارسال شده
          </div>
          <div className="from__button">
            <button onClick={sendCodeHandler} style={{ whiteSpace: 'nowrap' }}>
              <span style={loading ? {display: 'none'} : {}}>ثبت کد اعتبارسنجی</span>
              <img style={loading ? {} : {display: 'none'}} className='loadingPic' src={loadingPic} alt='loadingPic' />
            </button>
          </div>
        </section>
        <section className='copyright'>
          قدرت گرفته از <Link to='https://ibills.ir'>Ibills</Link> ، توسعه توسط <Link to='https://ham-team.ir'>هم‌تیم</Link>
        </section>
      </main>
    </div>
  )
}
